import React, { useState, useCallback } from 'react';
import { MdCheck } from 'react-icons/md';
import ProTypes from 'prop-types';

import { SaveCodeContainer, Checkbox } from './styles';

function SaveCode({ name, onNameChange }) {
    const [saveCode, setSaveCode] = useState(false);

    const handleSaveCode = useCallback(() => {
        const toggleSaveCode = !saveCode;

        console.log('save code');

        setSaveCode(toggleSaveCode);

        if (toggleSaveCode) {
            setTimeout(
                () => document.querySelector('#input-code-name').focus(),
                300
            );
        }
    }, [setSaveCode, saveCode]);

    return (
        <SaveCodeContainer nameCode={saveCode}>
            <label htmlFor="checkbox-code-save" className="select-save-code">
                <input
                    type="checkbox"
                    name="checkbox-code-save"
                    id="checkbox-code-save"
                    checked={saveCode}
                    onChange={handleSaveCode}
                />
                <Checkbox className="styled-checkbox" checked={saveCode}>
                    <MdCheck />
                </Checkbox>
                <span className="label-checkbox">salvar código</span>
            </label>
            <input
                placeholder="Nome do código"
                name="input-code-name"
                id="input-code-name"
                value={name}
                onChange={evt => onNameChange(evt.target.value)}
            />
        </SaveCodeContainer>
    );
}

SaveCode.propTypes = {
    name: ProTypes.string.isRequired,
    onNameChange: ProTypes.func.isRequired,
};

export default SaveCode;
